export default "__VITE_ASSET__BQhtu3Gt__"